export const FLOW_TYPES = {
  uploadingPhoto: 'uploading-photo',
  editPhoto: 'edit-photo',
  editMainPhoto: 'edit-main-photo',
  viewMainPhoto: 'main-photo',
  viewGalleryPhoto: 'gallery-photo',
  changeMainPhotoFlow: 'change-main-photo',
}